import React from "react";

import AppWrapper from "../../components/cm/AppWrapper";
import AddUserStandalone from "../../components/cm/Dashboard/FullPages/UserManager/UserProfileManager/AddUserStandalone";
import SideBarMain from "../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <AddUserStandalone />
    </AppWrapper.WithSidebar>
  );
};
